import { render, staticRenderFns } from "./AbstractLayout.vue?vue&type=template&id=71461fdd&scoped=true"
import script from "./AbstractLayout.vue?vue&type=script&lang=js"
export * from "./AbstractLayout.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./AbstractLayout.vue?vue&type=style&index=0&id=71461fdd&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "71461fdd",
  null
  ,true
)

export default component.exports